import HomeIcon from '@material-ui/icons/Home';
import { createFrontendModule, PageBlueprint } from '@backstage/frontend-plugin-api';

const homePage = PageBlueprint.make({
  params: {
    path: '/',
    title: 'Home',
    icon: <HomeIcon />,
    noHeader: true,
    loader: async () => {
      const { HomePage } = await import('./HomePage');
      return <HomePage />;
    },
  },
});

export const homeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [homePage],
});
